export default __webpack_public_path__ + "static/media/healthcare.d025d8db.svg";